import React, { useEffect, useState } from 'react';
import { req } from '../services/api';
import Modal from '../components/Modal';

const money = value => Number(value || 0).toFixed(2) + ' €';

const formatDate = value => {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('cs-CZ');
};

const normalize = value =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const DOCUMENTS = [
  ['idCardFront', 'OP / doklad totožnosti – přední strana'],
  ['idCardBack', 'OP / doklad totožnosti – zadní strana'],
  ['drivingLicenseFront', 'Řidičský průkaz – přední strana'],
  ['drivingLicenseBack', 'Řidičský průkaz – zadní strana'],
  ['taxiCard', 'Průkaz taxi'],
  ['registryDoc', 'Výpis z obchodního rejstříku'],
  ['bankStatement', 'Doklad k bankovnímu účtu'],
  ['fleetVatDoc', 'Doklad k DPH'],
  ['signedGdpr', 'Podepsané GDPR'],
  ['signedLicense', 'Licenční smlouva'],
  ['signedVop', 'Obchodní podmínky']
];

export default function Fleets() {
  const [fleets, setFleets] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const [detailModal, setDetailModal] = useState(false);
  const [docsModal, setDocsModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);

  const [currentFleet, setCurrentFleet] = useState(null);
  const [docsFleet, setDocsFleet] = useState(null);
  const [currentDocs, setCurrentDocs] = useState(null);

  const [editForm, setEditForm] = useState({
    name: '',
    email: '',
    phone: '',
    ico: ''
  });

  const [newPassword, setNewPassword] = useState('');

  useEffect(() => {
    loadFleets();
  }, []);

  const loadFleets = async () => {
    setLoading(true);

    try {
      const data = await req('GET', '/fleets');

      if (Array.isArray(data)) {
        setFleets(data);
      }
    } catch (error) {
      console.error('Fleets load failed:', error);
      alert(
        'Chyba p\u0159i na\u010d\u00edt\u00e1n\u00ed flotil: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    } finally {
      setLoading(false);
    }
  };

  const q = normalize(search);

  const filtered = fleets.filter(f => {
    const matchesSearch =
      normalize(f.companyName).includes(q) ||
      normalize(f.user?.name).includes(q) ||
      normalize(f.user?.email).includes(q) ||
      normalize(f.user?.phone).includes(q) ||
      normalize(f.ico).includes(q) ||
      normalize(f.dic).includes(q);

    const matchesFilter =
      filter === 'all' ||
      (filter === 'approval' && !f.approved && !f.blocked) ||
      (filter === 'documents' && !f.docsApproved && !f.blocked) ||
      (filter === 'active' && f.approved && f.docsApproved && !f.blocked) ||
      (filter === 'blocked' && f.blocked);

    return matchesSearch && matchesFilter;
  });

  const pendingAccounts = fleets.filter(
    f => !f.approved && !f.blocked
  ).length;

  const pendingDocs = fleets.filter(
    f => !f.docsApproved && !f.blocked
  ).length;

  const totalDrivers = fleets.reduce(
    (sum, f) => sum + Number(f._count?.drivers || 0),
    0
  );

  const totalVehicles = fleets.reduce(
    (sum, f) => sum + Number(f._count?.vehicles || 0),
    0
  );

  const totalWallet = fleets.reduce(
    (sum, f) => sum + Number(f.walletBalance || 0),
    0
  );

  const approve = async id => {
    try {
      await req('PATCH', '/fleets/' + id, { approved: true });
      await loadFleets();
    } catch (error) {
      alert(
        'Chyba p\u0159i schvalov\u00e1n\u00ed flotily: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const block = async (id, blocked) => {
    try {
      await req('PATCH', '/fleets/' + id, { blocked });
      await loadFleets();
    } catch (error) {
      alert(
        'Chyba p\u0159i zm\u011bn\u011b stavu flotily: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const deleteAccount = async fleet => {
    if (
      !window.confirm(
        'Opravdu chcete odstranit \u00fa\u010det flotily ' +
          fleet.companyName +
          ' z provozu? \u00da\u010det ji\u017e nebude mo\u017en\u00e9 pou\u017e\u00edvat, ale historie j\u00edzd a financ\u00ed z\u016fstane zachov\u00e1na.'
      )
    ) {
      return;
    }

    try {
      const result = await req(
        'DELETE',
        '/users/' + fleet.user.id
      );

      if (result?.success) {
        alert('\u00da\u010det flotily byl odstran\u011bn z provozu.');
        setDetailModal(false);
        await loadFleets();
      } else {
        alert(
          'Chyba p\u0159i odstra\u0148ov\u00e1n\u00ed: ' +
            (result?.error || 'nezn\u00e1m\u00e1 chyba')
        );
      }
    } catch (error) {
      alert(
        'Chyba p\u0159i odstra\u0148ov\u00e1n\u00ed: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const openDetail = fleet => {
    setCurrentFleet(fleet);
    setDetailModal(true);
  };

  const openDocs = async fleet => {
    setDocsFleet(fleet);
    setCurrentDocs(null);
    setDocsModal(true);

    try {
      const data = await req(
        'GET',
        '/fleets/' + fleet.id + '/documents'
      );

      setCurrentDocs(data);
    } catch (error) {
      setDocsModal(false);
      alert(
        'Chyba p\u0159i na\u010d\u00edt\u00e1n\u00ed dokument\u016f flotily: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const approveDocs = async approved => {
    try {
      await req(
        'PATCH',
        '/fleets/' + docsFleet.id + '/documents/approve',
        { approved }
      );

      setDocsModal(false);
      await loadFleets();

      alert(
        approved
          ? '\u2713 Dokumenty flotily byly schv\u00e1leny'
          : 'Dokumenty flotily byly zam\u00edtnuty'
      );
    } catch (error) {
      alert(
        'Chyba p\u0159i zpracov\u00e1n\u00ed dokument\u016f flotily: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const openDocument = value => {
    if (!value) return;

    let documentValue = value;

    if (typeof documentValue === 'string') {
      const trimmed = documentValue.trim();

      if (trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            documentValue = parsed.find(Boolean) || null;
          }
        } catch (e) {
          console.error('Nepodarilo se nacist JSON dokument:', e);
        }
      }
    }

    if (Array.isArray(documentValue)) {
      documentValue = documentValue.find(Boolean) || null;
    }

    if (!documentValue || typeof documentValue !== 'string') {
      alert('Dokument nelze zobrazit.');
      return;
    }

    const w = window.open();

    if (!w) {
      alert('Prohlížeč zablokoval otevření dokumentu.');
      return;
    }

    if (documentValue.startsWith('data:application/pdf')) {
      w.document.write(
        '<iframe src="' +
          documentValue +
          '" style="position:fixed;inset:0;width:100%;height:100%;border:0;"></iframe>'
      );
    } else {
      w.document.write(
        '<body style="margin:0;background:#111;text-align:center;">' +
          '<img src="' +
          documentValue +
          '" style="max-width:100%;max-height:100vh;" />' +
          '</body>'
      );
    }

    w.document.close();
  };

  const openEdit = fleet => {
    setCurrentFleet(fleet);

    setEditForm({
      name: fleet.user?.name || '',
      email: fleet.user?.email || '',
      phone: fleet.user?.phone || '',
      ico: fleet.ico || ''
    });

    setEditModal(true);
  };

  const saveEdit = async () => {
    try {
      await req(
        'PATCH',
        '/fleets/' + currentFleet.id + '/edit',
        editForm
      );

      setEditModal(false);
      await loadFleets();
      alert('\u2713 Flotila byla upravena');
    } catch (error) {
      alert(
        'Chyba p\u0159i \u00faprav\u011b flotily: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  const openPassword = fleet => {
    setCurrentFleet(fleet);
    setNewPassword('');
    setPasswordModal(true);
  };

  const savePassword = async () => {
    if (!newPassword || newPassword.length < 6) {
      alert('Heslo mus\u00ed m\u00edt alespo\u0148 6 znak\u016f');
      return;
    }

    try {
      await req(
        'PATCH',
        '/users/' + currentFleet.user.id + '/password',
        { password: newPassword }
      );

      setPasswordModal(false);
      alert('\u2713 Heslo bylo zm\u011bn\u011bno');
    } catch (error) {
      alert(
        'Chyba p\u0159i zm\u011bn\u011b hesla: ' +
          (error?.message || 'nezn\u00e1m\u00e1 chyba')
      );
    }
  };

  return (
    <div>
      <div className="page-title">Flotily</div>

      <div className="page-sub">
        Firemní účty, řidiči flotil, vozidla, dokumenty a provoz
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{fleets.length}</div>
          <div className="stat-label">Celkem flotil</div>
        </div>

        <div
          className={
            pendingAccounts > 0 ? 'stat-card alert' : 'stat-card'
          }
        >
          <div className="stat-value">{pendingAccounts}</div>
          <div className="stat-label">Čeká schválení účtu</div>
        </div>

        <div
          className={
            pendingDocs > 0 ? 'stat-card alert' : 'stat-card'
          }
        >
          <div className="stat-value">{pendingDocs}</div>
          <div className="stat-label">Čekají dokumenty</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{totalDrivers}</div>
          <div className="stat-label">Řidiči flotil</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{totalVehicles}</div>
          <div className="stat-label">Vozidla flotil</div>
        </div>

        <div className="stat-card">
          <div className="stat-value">{money(totalWallet)}</div>
          <div className="stat-label">V peněženkách</div>
        </div>
      </div>

      <div className="admin-toolbar">
        <input
          className="search-bar"
          placeholder="Hledat firmu, e-mail, telefon, IČO nebo DIČ..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <button
          className={
            'btn-sm ' +
            (filter === 'all' ? 'btn-gold' : 'btn-gray')
          }
          onClick={() => setFilter('all')}
        >
          Všechny
        </button>

        <button
          className={
            'btn-sm ' +
            (filter === 'approval' ? 'btn-red' : 'btn-gray')
          }
          onClick={() => setFilter('approval')}
        >
          Čeká účet
        </button>

        <button
          className={
            'btn-sm ' +
            (filter === 'documents' ? 'btn-red' : 'btn-gray')
          }
          onClick={() => setFilter('documents')}
        >
          Čekají dokumenty
        </button>

        <button
          className={
            'btn-sm ' +
            (filter === 'active' ? 'btn-green' : 'btn-gray')
          }
          onClick={() => setFilter('active')}
        >
          Aktivní
        </button>

        <button
          className={
            'btn-sm ' +
            (filter === 'blocked' ? 'btn-red' : 'btn-gray')
          }
          onClick={() => setFilter('blocked')}
        >
          Blokované
        </button>
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Flotily</span>

          <span className="dashboard-muted">
            Zobrazeno {filtered.length} z {fleets.length}
          </span>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Flotila</th>
                <th>Účet</th>
                <th>Dokumenty</th>
                <th>Řidiči</th>
                <th>Vozidla</th>
                <th>Jízdy</th>
                <th>Pracovní režim</th>
                <th>Hodnocení</th>
                <th>Peněženka</th>
                <th>Akce</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="loading-cell">
                    Načítám...
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan="10" className="empty-cell">
                    Žádné flotily
                  </td>
                </tr>
              ) : (
                filtered.map(f => (
                  <tr key={f.id}>
                    <td>
                      <strong>{f.companyName || '—'}</strong>
                      <br />
                      <span className="table-secondary">
                        {f.user?.email || '—'}
                      </span>
                      {f.ico && (
                        <>
                          <br />
                          <span className="table-secondary">
                            IČO {f.ico}
                          </span>
                        </>
                      )}
                    </td>

                    <td>
                      {f.blocked ? (
                        <span className="badge badge-red">
                          Blokována
                        </span>
                      ) : f.approved ? (
                        <span className="badge badge-green">
                          Schválena
                        </span>
                      ) : (
                        <span className="badge badge-gold">
                          Čeká
                        </span>
                      )}
                    </td>

                    <td>
                      {f.docsApproved ? (
                        <span className="badge badge-green">
                          Schváleny
                        </span>
                      ) : (
                        <span className="badge badge-gold">
                          Čekají
                        </span>
                      )}
                    </td>

                    <td>
                      <strong>{f._count?.drivers || 0}</strong>
                    </td>

                    <td>
                      <strong>{f._count?.vehicles || 0}</strong>
                    </td>

                    <td>
                      <strong>{f._count?.rides || 0}</strong>
                    </td>

                    <td>
                      {f.workMode ? (
                        <>
                          <strong>{f.workMode}</strong>

                          {f.workRadius && (
                            <>
                              <br />
                              <span className="table-secondary">
                                {f.workRadius} km
                              </span>
                            </>
                          )}

                          {f.workCountries && (
                            <>
                              <br />
                              <span className="table-secondary">
                                {f.workCountries}
                              </span>
                            </>
                          )}
                        </>
                      ) : (
                        '—'
                      )}
                    </td>

                    <td>
                      <span className="gold-text">
                        ★ {Number(f.rating || 0).toFixed(1)}
                      </span>
                    </td>

                    <td className="gold-text">
                      {money(f.walletBalance)}
                    </td>

                    <td>
                      <div className="actions">
                        <button
                          className="btn-sm btn-blue"
                          onClick={() => openDetail(f)}
                        >
                          Detail
                        </button>

                        <button
                          className={
                            'btn-sm ' +
                            (f.docsApproved
                              ? 'btn-green'
                              : 'btn-gold')
                          }
                          onClick={() => openDocs(f)}
                        >
                          Dokumenty
                        </button>

                        {!f.approved && !f.blocked && (
                          <button
                            className="btn-sm btn-green"
                            onClick={() => approve(f.id)}
                          >
                            Schválit
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {detailModal && currentFleet && (
        <Modal
          title="Detail flotily"
          onClose={() => setDetailModal(false)}
        >
          <div className="payout-detail-box">
            <div className="payout-row">
              <span className="payout-row-label">Firma</span>
              <span className="payout-row-value">
                {currentFleet.companyName || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Kontaktní osoba
              </span>
              <span className="payout-row-value">
                {currentFleet.user?.name || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">E-mail</span>
              <span className="payout-row-value">
                {currentFleet.user?.email || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">Telefon</span>
              <span className="payout-row-value">
                {currentFleet.user?.phone || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">Adresa</span>
              <span className="payout-row-value">
                {currentFleet.user?.address || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">Jazyk</span>
              <span className="payout-row-value">
                {(currentFleet.user?.language || 'cs').toUpperCase()}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">IČO</span>
              <span className="payout-row-value">
                {currentFleet.ico || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">DIČ</span>
              <span className="payout-row-value">
                {currentFleet.dic || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">Plátce DPH</span>
              <span className="payout-row-value">
                {currentFleet.isVatPayer == null
                  ? '—'
                  : currentFleet.isVatPayer
                    ? 'Ano'
                    : 'Ne'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Číslo licence
              </span>
              <span className="payout-row-value">
                {currentFleet.licenseNumber || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">Účet</span>
              <span className="payout-row-value">
                {currentFleet.blocked
                  ? 'Blokován'
                  : currentFleet.approved
                    ? 'Schválen'
                    : 'Čeká na schválení'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Dokumenty
              </span>
              <span className="payout-row-value">
                {currentFleet.docsApproved
                  ? 'Schváleny'
                  : 'Čekají na schválení'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Řidiči flotily
              </span>
              <span className="payout-row-value">
                {currentFleet._count?.drivers || 0}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Vozidla
              </span>
              <span className="payout-row-value">
                {currentFleet._count?.vehicles || 0}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Jízdy
              </span>
              <span className="payout-row-value">
                {currentFleet._count?.rides || 0}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Hodnocení
              </span>
              <span className="payout-row-value">
                {Number(currentFleet.rating || 0).toFixed(1)}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Pracovní režim
              </span>
              <span className="payout-row-value">
                {currentFleet.workMode || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Pracovní rádius
              </span>
              <span className="payout-row-value">
                {currentFleet.workRadius
                  ? currentFleet.workRadius + ' km'
                  : '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Země
              </span>
              <span className="payout-row-value">
                {currentFleet.workCountries || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Způsob výplaty
              </span>
              <span className="payout-row-value">
                {currentFleet.payoutMethod || '—'}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Peněženka
              </span>
              <span className="payout-row-value gold-text">
                {money(currentFleet.walletBalance)}
              </span>
            </div>

            <div className="payout-row">
              <span className="payout-row-label">
                Registrace
              </span>
              <span className="payout-row-value">
                {formatDate(currentFleet.createdAt)}
              </span>
            </div>
          </div>

          <div className="actions">
            <button
              className="btn-sm btn-gold"
              onClick={() => {
                setDetailModal(false);
                openDocs(currentFleet);
              }}
            >
              Dokumenty
            </button>

            <button
              className="btn-sm btn-gold"
              onClick={() => {
                setDetailModal(false);
                openEdit(currentFleet);
              }}
            >
              Upravit
            </button>

            <button
              className="btn-sm btn-gold"
              onClick={() => {
                setDetailModal(false);
                openPassword(currentFleet);
              }}
            >
              Změnit heslo
            </button>

            {!currentFleet.blocked ? (
              <button
                className="btn-sm btn-red"
                onClick={async () => {
                  await block(currentFleet.id, true);
                  setDetailModal(false);
                }}
              >
                Blokovat
              </button>
            ) : (
              <button
                className="btn-sm btn-green"
                onClick={async () => {
                  await block(currentFleet.id, false);
                  setDetailModal(false);
                }}
              >
                Odblokovat
              </button>
            )}

            <button
              className="btn-sm btn-red"
              onClick={() => deleteAccount(currentFleet)}
            >
              Smazat účet
            </button>
          </div>
        </Modal>
      )}

      {docsModal && docsFleet && (
        <Modal
          title={
            'Dokumenty – ' +
            (docsFleet.companyName || docsFleet.user?.name || 'flotila')
          }
          onClose={() => setDocsModal(false)}
          actions={
            currentDocs ? (
              <>
                <button
                  className="btn-gray"
                  onClick={() => approveDocs(false)}
                >
                  Zamítnout
                </button>

                <button
                  className="btn"
                  onClick={() => approveDocs(true)}
                >
                  Schválit dokumenty
                </button>
              </>
            ) : null
          }
        >
          {!currentDocs ? (
            <div className="loading-cell">
              Načítám dokumenty...
            </div>
          ) : (
            <>
              <div style={{ marginBottom: 16 }}>
                {currentDocs.docsApproved ? (
                  <span className="badge badge-green">
                    Dokumenty jsou schválené
                  </span>
                ) : (
                  <span className="badge badge-gold">
                    Dokumenty čekají na schválení
                  </span>
                )}
              </div>

              <div className="document-list">
                {DOCUMENTS.map(([key, label]) => (
                  <div className="document-row" key={key}>
                    <div>
                      <strong>{label}</strong>

                      <div className="table-secondary">
                        {currentDocs[key]
                          ? 'Dokument nahrán'
                          : 'Nenahráno'}
                      </div>
                    </div>

                    {currentDocs[key] && (
                      <button
                        className="btn-sm btn-blue"
                        onClick={() =>
                          openDocument(currentDocs[key])
                        }
                      >
                        Zobrazit
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </Modal>
      )}

      {editModal && currentFleet && (
        <Modal
          title="Editace flotily"
          onClose={() => setEditModal(false)}
          actions={
            <>
              <button
                className="btn-gray"
                onClick={() => setEditModal(false)}
              >
                Zrušit
              </button>

              <button className="btn" onClick={saveEdit}>
                Uložit
              </button>
            </>
          }
        >
          <div className="edit-row">
            <label className="edit-label">
              Kontaktní osoba
            </label>

            <input
              value={editForm.name}
              onChange={e =>
                setEditForm({
                  ...editForm,
                  name: e.target.value
                })
              }
            />
          </div>

          <div className="edit-row">
            <label className="edit-label">E-mail</label>

            <input
              value={editForm.email}
              onChange={e =>
                setEditForm({
                  ...editForm,
                  email: e.target.value
                })
              }
            />
          </div>

          <div className="edit-row">
            <label className="edit-label">Telefon</label>

            <input
              value={editForm.phone}
              onChange={e =>
                setEditForm({
                  ...editForm,
                  phone: e.target.value
                })
              }
            />
          </div>

          <div className="edit-row">
            <label className="edit-label">IČO</label>

            <input
              value={editForm.ico}
              onChange={e =>
                setEditForm({
                  ...editForm,
                  ico: e.target.value
                })
              }
            />
          </div>
        </Modal>
      )}

      {passwordModal && currentFleet && (
        <Modal
          title="Změna hesla flotily"
          onClose={() => setPasswordModal(false)}
          actions={
            <>
              <button
                className="btn-gray"
                onClick={() => setPasswordModal(false)}
              >
                Zrušit
              </button>

              <button className="btn" onClick={savePassword}>
                Uložit
              </button>
            </>
          }
        >
          <p
            style={{
              color: 'var(--gray)',
              fontSize: 13,
              marginBottom: 16
            }}
          >
            Flotila: {currentFleet.companyName}
          </p>

          <input
            type="password"
            placeholder="Nové heslo (min. 6 znaků)"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
          />
        </Modal>
      )}
    </div>
  );
}
